export const historyTranslations = {
  en: {
    headerTitle: "History",
    all_sports: "All Sports",
    search_placeholder: "Search",
    select_title_placeholder: "Select Title",
    select_days_placeholder: "Select Days",
    last_7_days: "Last 7 days",
    last_30_days: "Last 30 days",
    last_90_days: "Last 90 days",
    reset_filters: "Reset all filters",
    no_activities_found: "No activities found matching your criteria.",
  },
  de: {
    all_sports: "Alle Sportarten",
    search_placeholder: "Suchen",
    select_title_placeholder: "Titel auswählen",
    select_days_placeholder: "Tage auswählen",
    last_7_days: "Letzte 7 Tage",
    last_30_days: "Letzte 30 Tage",
    last_90_days: "Letzte 90 Tage",
    reset_filters: "Alle Filter zurücksetzen",
    no_activities_found: "Keine Aktivitäten gefunden, die Ihren Kriterien entsprechen.",
  },
  hr: {
    all_sports: "Svi sportovi",
    search_placeholder: "Pretraži",
    select_title_placeholder: "Odaberi naslov",
    select_days_placeholder: "Odaberi dane",
    last_7_days: "Zadnjih 7 dana",
    last_30_days: "Zadnjih 30 dana",
    last_90_days: "Zadnjih 90 dana",
    reset_filters: "Poništi sve filtre",
    no_activities_found: "Nema pronađenih aktivnosti koje odgovaraju vašim kriterijima.",
  },
};